<p-toast></p-toast>
<div class="grid">
    <div class="col-12">
        <!-- Project Information -->
        <div class="fluid formgrid grid">
            <div class="flex flex-column gap-2 my-2 col-12 md:col-6">
                <label for="emplacementId">Emplacement<span class="requis">*</span></label>
                <p-dropdown id="emplacementId" [options]="emplacements" [(ngModel)]="evaluation.emplacement"
                    optionLabel="nom" [filter]="true" filterBy="nom" [loading]="!emplacements"
                    placeholder="Sélectionner un emplacement" [disabled]="modeConsultation()">
                    <ng-template pTemplate="selectedItem" let-selectedItem>
                        <div class="flex justify-content-between align-items-center gap-2">
                            <span>{{selectedItem.nom}}</span>
                            <span>{{selectedItem.code}}</span>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="item" let-item>
                        <div class="flex justify-content-between align-items-center gap-2">
                            <span>{{item.nom}}</span>
                            <span>{{item.code}}</span>
                        </div>
                    </ng-template>
                </p-dropdown>
                <small class="p-error" *ngIf="submitted && !evaluation.emplacement">L'emplacement est
                    obligatoire.</small>
            </div>
            <div class="flex flex-column gap-2 my-2 col-12">
                <label for="productsServices">Produits/Services achetés<span class="requis">*</span></label>
                <input id="productsServices" type="text" pInputText [(ngModel)]="evaluation.productsServices"
                    [readonly]="modeConsultation()">
                <small class="p-error" *ngIf="submitted && !evaluation.productsServices">Les produits/services sont
                    obligatoires.</small>
            </div>
        </div>

        <!-- Product Quality -->
        <div class="mt-4">
            <p-divider align="left">
                <span>1) Qualité du produit/service livré<span class="requis">*</span></span>
            </p-divider>
            <p-table [value]="[1]" styleClass="p-datatable-sm">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Critères</th>
                        <th>Mauvais</th>
                        <th>Acceptable</th>
                        <th>Bon</th>
                        <th>Très bon</th>
                        <th>N/A</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body">
                    <tr>
                        <td style="width: 40%">Qualité du produit/service livré selon les attentes<span
                                class="requis">*</span></td>
                        <td *ngFor="let option of ratingOptions" style="width: 12%">
                            <p-radioButton [value]="option.value" [(ngModel)]="evaluation.qualityExpectations"
                                [disabled]="modeConsultation()">
                            </p-radioButton>
                        </td>
                    </tr>
                    <small class="p-error" *ngIf="submitted && !evaluation.qualityExpectations">Ce champ est
                        obligatoire.</small>
                    <tr>
                        <td style="width: 40%">Précision des produits/services livrés<span class="requis">*</span></td>
                        <td *ngFor="let option of ratingOptions" style="width: 12%">
                            <p-radioButton [value]="option.value" [(ngModel)]="evaluation.productAccuracy"
                                [disabled]="modeConsultation()">
                            </p-radioButton>
                        </td>
                    </tr>
                    <small class="p-error" *ngIf="submitted && !evaluation.productAccuracy">Ce champ est
                        obligatoire.</small>
                    <tr>
                        <td style="width: 40%">Précision des quantités livrées<span class="requis">*</span></td>
                        <td *ngFor="let option of ratingOptions" style="width: 12%">
                            <p-radioButton [value]="option.value" [(ngModel)]="evaluation.quantityAccuracy"
                                [disabled]="modeConsultation()">
                            </p-radioButton>
                        </td>
                    </tr>
                    <small class="p-error" *ngIf="submitted && !evaluation.quantityAccuracy">Ce champ est
                        obligatoire.</small>
                    <tr>
                        <td style="width: 40%">Rapidité de correction des non-conformités<span class="requis">*</span>
                        </td>
                        <td *ngFor="let option of ratingOptions" style="width: 12%">
                            <p-radioButton [value]="option.value" [(ngModel)]="evaluation.correctionSpeed"
                                [disabled]="modeConsultation()">
                            </p-radioButton>
                        </td>
                    </tr>
                    <small class="p-error" *ngIf="submitted && !evaluation.correctionSpeed">Ce champ est
                        obligatoire.</small>
                </ng-template>
            </p-table>
        </div>

        <!-- Service Quality -->
        <div class="mt-4">
            <p-divider align="left">
                <span>2) Qualité de service<span class="requis">*</span></span>
            </p-divider>
            <p-table [value]="[1]" styleClass="p-datatable-sm">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Critères</th>
                        <th>Mauvais</th>
                        <th>Acceptable</th>
                        <th>Bon</th>
                        <th>Très bon</th>
                        <th>N/A</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body">
                    <tr>
                        <td style="width: 40%">Flexibilité des délais de livraison<span class="requis">*</span></td>
                        <td *ngFor="let option of ratingOptions" style="width: 12%">
                            <p-radioButton [value]="option.value" [(ngModel)]="evaluation.deliveryFlexibility"
                                [disabled]="modeConsultation()">
                            </p-radioButton>
                        </td>
                    </tr>
                    <small class="p-error" *ngIf="submitted && !evaluation.deliveryFlexibility">Ce champ est
                        obligatoire.</small>
                    <tr>
                        <td style="width: 40%">Respect des délais de livraison<span class="requis">*</span></td>
                        <td *ngFor="let option of ratingOptions" style="width: 12%">
                            <p-radioButton [value]="option.value" [(ngModel)]="evaluation.deliveryDeadlines"
                                [disabled]="modeConsultation()">
                            </p-radioButton>
                        </td>
                    </tr>
                    <small class="p-error" *ngIf="submitted && !evaluation.deliveryDeadlines">Ce champ est
                        obligatoire.</small>
                    <tr>
                        <td style="width: 40%">Délai de réponse pour les prix<span class="requis">*</span></td>
                        <td *ngFor="let option of ratingOptions" style="width: 12%">
                            <p-radioButton [value]="option.value" [(ngModel)]="evaluation.priceResponseTime"
                                [disabled]="modeConsultation()">
                            </p-radioButton>
                        </td>
                    </tr>
                    <small class="p-error" *ngIf="submitted && !evaluation.priceResponseTime">Ce champ est
                        obligatoire.</small>
                    <tr>
                        <td style="width: 40%">Service de garantie<span class="requis">*</span></td>
                        <td *ngFor="let option of ratingOptions" style="width: 12%">
                            <p-radioButton [value]="option.value" [(ngModel)]="evaluation.serviceWarranty"
                                [disabled]="modeConsultation()">
                            </p-radioButton>
                        </td>
                    </tr>
                    <small class="p-error" *ngIf="submitted && !evaluation.serviceWarranty">Ce champ est
                        obligatoire.</small>
                    <tr>
                        <td style="width: 40%">Qualité des contacts<span class="requis">*</span></td>
                        <td *ngFor="let option of ratingOptions" style="width: 12%">
                            <p-radioButton [value]="option.value" [(ngModel)]="evaluation.contactQuality"
                                [disabled]="modeConsultation()">
                            </p-radioButton>
                        </td>
                    </tr>
                    <small class="p-error" *ngIf="submitted && !evaluation.contactQuality">Ce champ est
                        obligatoire.</small>
                </ng-template>
            </p-table>
        </div>

        <!-- Pricing Policy -->
        <div class="mt-4">
            <p-divider align="left">
                <span>3) Politique de prix<span class="requis">*</span></span>
            </p-divider>
            <p-table [value]="[1]" styleClass="p-datatable-sm">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 40%">Critères</th>
                        <th>Mauvais</th>
                        <th>Acceptable</th>
                        <th>Bon</th>
                        <th>Très bon</th>
                        <th>N/A</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body">
                    <tr>
                        <td style="width: 40%">Clarté des prix<span class="requis">*</span></td>
                        <td *ngFor="let option of ratingOptions" style="width: 12%">
                            <p-radioButton [value]="option.value" [(ngModel)]="evaluation.pricingClarity"
                                [disabled]="modeConsultation()">
                            </p-radioButton>
                        </td>
                    </tr>
                    <small class="p-error" *ngIf="submitted && !evaluation.pricingClarity">Ce champ est
                        obligatoire.</small>
                    <tr>
                        <td style="width: 40%">Rapport qualité/prix<span class="requis">*</span></td>
                        <td *ngFor="let option of ratingOptions" style="width: 12%">
                            <p-radioButton [value]="option.value" [(ngModel)]="evaluation.qualityPriceRatio"
                                [disabled]="modeConsultation()">
                            </p-radioButton>
                        </td>
                    </tr>
                    <small class="p-error" *ngIf="submitted && !evaluation.qualityPriceRatio">Ce champ est
                        obligatoire.</small>
                    <tr>
                        <td style="width: 40%">Politique de paiement<span class="requis">*</span></td>
                        <td *ngFor="let option of ratingOptions" style="width: 12%">
                            <p-radioButton [value]="option.value" [(ngModel)]="evaluation.paymentPolicy"
                                [disabled]="modeConsultation()">
                            </p-radioButton>
                        </td>
                    </tr>
                    <small class="p-error" *ngIf="submitted && !evaluation.paymentPolicy">Ce champ est
                        obligatoire.</small>
                </ng-template>
            </p-table>
        </div>

        <!-- On-site Work -->
        <div class="mt-4" *ngIf="sousTraitant">
            <p-divider align="left">
                <span>4) Évaluation du travail à pied d'œuvre<span class="requis">*</span></span>
            </p-divider>
            <p-table [value]="[1]" styleClass="p-datatable-sm">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 40%">Critères</th>
                        <th>Mauvais</th>
                        <th>Acceptable</th>
                        <th>Bon</th>
                        <th>Très bon</th>
                        <th>N/A</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body">
                    <tr>
                        <td style="width: 40%">Prise en charge global de la SST<span class="requis">*</span></td>
                        <td *ngFor="let option of ratingOptions" style="width: 12%">
                            <p-radioButton [value]="option.value" [(ngModel)]="evaluation.sstmanagement"
                                [disabled]="modeConsultation()">
                            </p-radioButton>
                        </td>
                    </tr>

                    <small class="p-error" *ngIf="submitted && !evaluation.sstmanagement">Ce champ est
                        obligatoire.</small>
                    <tr>
                        <td style="width: 40%">Respect des délais<span class="requis">*</span></td>
                        <td *ngFor="let option of ratingOptions" style="width: 12%">
                            <p-radioButton [value]="option.value" [(ngModel)]="evaluation.deadlineRespect"
                                [disabled]="modeConsultation()">
                            </p-radioButton>
                        </td>
                    </tr>
                    <small class="p-error" *ngIf="submitted && !evaluation.deadlineRespect">Ce champ est
                        obligatoire.</small>
                    <tr>
                        <td style="width: 40%">Qualité des travaux<span class="requis">*</span></td>
                        <td *ngFor="let option of ratingOptions" style="width: 12%">
                            <p-radioButton [value]="option.value" [(ngModel)]="evaluation.workQuality"
                                [disabled]="modeConsultation()">
                            </p-radioButton>
                        </td>
                    </tr>
                    <small class="p-error" *ngIf="submitted && !evaluation.workQuality">Ce champ est
                        obligatoire.</small>
                    <tr>
                        <td style="width: 40%">Qualité des documents transmis<span class="requis">*</span></td>
                        <td *ngFor="let option of ratingOptions" style="width: 12%">
                            <p-radioButton [value]="option.value" [(ngModel)]="evaluation.documentQuality"
                                [disabled]="modeConsultation()">
                            </p-radioButton>
                        </td>
                    </tr>
                    <small class="p-error" *ngIf="submitted && !evaluation.documentQuality">Ce champ est
                        obligatoire.</small>
                    <tr>
                        <td style="width: 40%">Supervision des travaux<span class="requis">*</span></td>
                        <td *ngFor="let option of ratingOptions" style="width: 12%">
                            <p-radioButton [value]="option.value" [(ngModel)]="evaluation.workSupervision"
                                [disabled]="modeConsultation()">
                            </p-radioButton>
                        </td>
                    </tr>
                    <small class="p-error" *ngIf="submitted && !evaluation.workSupervision">Ce champ est
                        obligatoire.</small>
                    <tr>
                        <td style="width: 40%">Communication et disponibilité<span class="requis">*</span></td>
                        <td *ngFor="let option of ratingOptions" style="width: 12%">
                            <p-radioButton [value]="option.value" [(ngModel)]="evaluation.communication"
                                [disabled]="modeConsultation()">
                            </p-radioButton>
                        </td>
                    </tr>
                    <small class="p-error" *ngIf="submitted && !evaluation.communication">Ce champ est
                        obligatoire.</small>
                    <tr>
                        <td style="width: 40%">Compétence de la main d'œuvre<span class="requis">*</span></td>
                        <td *ngFor="let option of ratingOptions" style="width: 12%">
                            <p-radioButton [value]="option.value" [(ngModel)]="evaluation.qualityOfWorkers"
                                [disabled]="modeConsultation()">
                            </p-radioButton>
                        </td>
                    </tr>
                    <small class="p-error" *ngIf="submitted && !evaluation.qualityOfWorkers">Ce champ est
                        obligatoire.</small>    
                    <tr>
                        <td style="width: 40%">Conformité légale<span class="requis">*</span></td>
                        <td *ngFor="let option of ratingOptions" style="width: 12%">
                            <p-radioButton [value]="option.value" [(ngModel)]="evaluation.legalCompliance"
                                [disabled]="modeConsultation()">
                            </p-radioButton>
                        </td>
                    </tr>
                    <small class="p-error" *ngIf="submitted && !evaluation.legalCompliance">Ce champ est
                        obligatoire.</small>
                    <tr>
                        <td style="width: 40%">Respect des politiques de Hamel Construction<span class="requis">*</span></td>
                        <td *ngFor="let option of ratingOptions" style="width: 12%">
                            <p-radioButton [value]="option.value" [(ngModel)]="evaluation.hamelConstructionPolicy"
                                [disabled]="modeConsultation()">
                            </p-radioButton>
                        </td>
                    </tr>
                    <small class="p-error" *ngIf="submitted && !evaluation.hamelConstructionPolicy">Ce champ est
                        obligatoire.</small>
                </ng-template>
            </p-table>
        </div>

        <!-- SST -->
        <div class="mt-4" *ngIf="sousTraitant">
            <p-divider align="left">
                <span>5) Évaluation des méthodes sécuritaires (SST)<span class="requis">*</span></span>
            </p-divider>
            <p-table [value]="[1]" styleClass="p-datatable-sm">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 40%">Critères</th>
                        <th>Mauvais</th>
                        <th>Acceptable</th>
                        <th>Bon</th>
                        <th>Très bon</th>
                        <th>N/A</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body">
                    <tr>
                        <td style="width: 40%">Méthodes de travail sécuritaire<span class="requis">*</span></td>
                        <td *ngFor="let option of ratingOptions" style="width: 12%">
                            <p-radioButton [value]="option.value" [(ngModel)]="evaluation.safeWorkingPractices"
                                [disabled]="modeConsultation()">
                            </p-radioButton>
                        </td>
                    </tr>
                    <small class="p-error" *ngIf="submitted && !evaluation.safeWorkingPractices">Ce champ est
                        obligatoire.</small>
                    <tr>
                        <td style="width: 40%">AST Quotidienne<span class="requis">*</span></td>
                        <td *ngFor="let option of ratingOptions" style="width: 12%">
                            <p-radioButton [value]="option.value" [(ngModel)]="evaluation.dailyAST"
                                [disabled]="modeConsultation()">
                            </p-radioButton>
                        </td>
                    </tr>
                    <small class="p-error" *ngIf="submitted && !evaluation.dailyAST">Ce champ est
                        obligatoire.</small>
                    <tr>
                        <td style="width: 40%">Port des EPI<span class="requis">*</span></td>
                        <td *ngFor="let option of ratingOptions" style="width: 12%">
                            <p-radioButton [value]="option.value" [(ngModel)]="evaluation.ppeCompliance"
                                [disabled]="modeConsultation()">
                            </p-radioButton>
                        </td>
                    </tr>
                    <small class="p-error" *ngIf="submitted && !evaluation.ppeCompliance">Ce champ est
                        obligatoire.</small>
                    <tr>
                        <td style="width: 40%">Supervision SST adéquate<span class="requis">*</span></td>
                        <td *ngFor="let option of ratingOptions" style="width: 12%">
                            <p-radioButton [value]="option.value" [(ngModel)]="evaluation.sstSupervision"
                                [disabled]="modeConsultation()">
                            </p-radioButton>
                        </td>
                    </tr>
                    <small class="p-error" *ngIf="submitted && !evaluation.sstSupervision">Ce champ est
                        obligatoire.</small>
                    <tr>
                        <td style="width: 40%">Indice de collaboration SST<span class="requis">*</span></td>
                        <td *ngFor="let option of ratingOptions" style="width: 12%">
                            <p-radioButton [value]="option.value" [(ngModel)]="evaluation.sstCollaborationIndice"
                                [disabled]="modeConsultation()">
                            </p-radioButton>
                        </td>
                    </tr>
                    <small class="p-error" *ngIf="submitted && !evaluation.sstCollaborationIndice">Ce champ est
                        obligatoire.</small>
                </ng-template>
            </p-table>
        </div>


        <!-- Commentaire -->
        <div class="mt-4">
            <p-divider align="left">
                <span>6) Commentaire</span>
            </p-divider>
            <span *ngIf="modeConsultation()" class="formatted-text block w-full" style="white-space: pre-wrap;">{{evaluation.notes}}</span>
            <textarea *ngIf="!modeConsultation()" pInputTextarea [(ngModel)]="evaluation.notes" rows="5" autoResize="autoResize" placeholder="Commentaire..." class="w-full"></textarea>
        </div>

        <!-- Submit Button -->
        <div class="flex justify-content-end gap-2 mt-4">
            <p-button *ngIf="!modeConsultation()" type="submit" label="Enregistrer" icon="pi pi-save" [disabled]="sent"
                (click)="onSubmit()"></p-button>
            <p-button type="button" label="Fermer" [outlined]="true" icon="pi pi-times"
                (onClick)="onCancel()"></p-button>
        </div>

    </div>
</div>